import { useOktaAuth } from '@okta/okta-react';
import OktaSignIn from '@okta/okta-signin-widget';
import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

import OktaAuth from '@okta/okta-auth-js';
import { toast } from 'react-toastify';
import { oktaConfig } from '../..';

import '@okta/okta-signin-widget/css/okta-sign-in.min.css';

export const Login = () => {
  const { oktaAuth, authState } = useOktaAuth();
  const navigate = useNavigate();

  console.log(oktaAuth, authState);
  useEffect(() => {
    if (authState && authState.isAuthenticated) {
      navigate('/home');
    }
  }, [authState]);

  const initiateOktaSignInWithRedirect = async () => {
    await oktaAuth.signInWithRedirect();
  };

  return (
    <div style={{ maxWidth: 420, margin: '40px auto' }} id="okta-widget-container">
      <OktaSignInWidget
        oktaAuth={oktaAuth}
        issuer={oktaConfig.issuer}
        clientId={oktaConfig.clientId}
        redirectUri={oktaConfig.redirectUri}
        onSuccess={async (tokens) => {
          // Tokens (idToken/accessToken) are stored in oktaAuth.tokenManager.
          // After successful sign-in, redirect wherever you want.
          await oktaAuth.authStateManager.updateAuthState();
          console.log(oktaAuth.tokenManager);
          navigate('/login');
        }}
        onError={(err) => {
          console.error('Widget sign-in error', err);
          toast.error('Error:', err);
        }}
      />
    </div>
  );

  // return (
  //   <div className="flex justify-center items-center py-10">
  //     <div className="card shadow-2xl bg-base-100 w-96 flex flex-col flex-center">
  //       <div className="card-body">
  //         <div className="text-2xl font-bold text-primary text-center">Welcome Back</div>
  //         <div className="divider m-0"></div>
  //         <div className="form-control items-center">
  //           <label htmlFor="" className="label">
  //             <span className="label-text text-2xl ">Authenticate</span>
  //           </label>
  //           <button className="btn btn-sm btn-outline btn-primary" onClick={() => initiateOktaSignInWithRedirect()}>
  //             Login with OKTA
  //           </button>
  //         </div>
  //       </div>
  //     </div>
  //   </div>
  // );
};

type Props = {
  oktaAuth: OktaAuth;
  issuer: string; // e.g., https://{yourOktaDomain}/oauth2/default
  clientId: string | undefined;
  redirectUri: string | undefined; // e.g., window.location.origin + '/callback'
  onSuccess?: (tokens: any) => void;
  onError?: (err: any) => void;
};

export function OktaSignInWidget({ oktaAuth, issuer, clientId, redirectUri, onSuccess, onError }: Props) {
  const elRef = useRef<HTMLDivElement | null>(null);
  const widgetRef = useRef<OktaSignIn | null>(null);

  console.log(issuer);
  useEffect(() => {
    if (!elRef.current) return;

    // Initialize the widget
    widgetRef.current = new OktaSignIn({
      baseUrl: issuer.replace('/oauth2/default', ''), // org URL
      clientId,
      authClient: oktaAuth,
      logo: `${window.location.origin}/logo.png`,
      authParams: {
        scopes: ['openid', 'profile', 'email'],
        issuer,

        responseType: 'code',
        pkce: true,
        cookies: {
          secure: true,
        },
        redirectUri,
        postLogoutRedirectUri: window.location.origin + '/login',
        tokenManager: {
          secure: true,
          storage: 'localStorage',
          autoRemove: true,
          autoRenew: true,
        },

        // The widget & Auth JS handle Interaction Code / PKCE behind the scenes
      },
      useInteractionCodeFlow: false,
      useClassicEngine: true,
    });

    // Render and use the helper to obtain tokens for the SPA
    widgetRef.current
      .showSignInToGetTokens({
        el: '#okta-widget-container',
        redirectUri, // must match one inyour app integration
      })
      .then((tokens) => {
        console.log(tokens);
        onSuccess?.(tokens);
      })
      .catch((err) => {
        onError?.(err);
      });

    const onSuccess = (tokens: any) => {
      oktaAuth.handleLoginRedirect(tokens);
    };

    const onError = (err: unknown) => {
      console.error(err);
    };
    widgetRef.current.authClient.session.get().then((session: any) => {
      if (widgetRef.current !== null) {
        widgetRef.current.authClient.token
          .getWithoutPrompt({
            responseType: oktaConfig.responseType,
          })
          .then(function (res: any) {
            const tokens = res.tokens;
            onSuccess(tokens);
          })
          .catch(function (err: unknown) {
            // handle OAuthError or AuthSdkError (AuthSdkError will be thrown if app is in OAuthCallback state)
            onError(err);
          });
      }
    });

    return () => {
      // Cleanup the widget on unmount
      widgetRef.current?.remove();
    };
  }, [oktaAuth, issuer, clientId, redirectUri, onSuccess, onError]);

  return <div ref={elRef} />;
}
